const LOCALE_OPTS = { sensitivity: 'base' };

const compareLabels = (a, b) => (a || '').localeCompare(b || '', 'es', LOCALE_OPTS);

export function getGuideItemPrintLabel(item) {
  return (item?.product?.name || item?.description || 'N/A').trim();
}

export function getDocumentItemPrintLabel(item) {
  if (item?.item_type === 'product') {
    return (item?.product?.name || item?.description || 'N/A').trim();
  }
  if (item?.item_type === 'service') {
    return (item?.service?.name || item?.description || 'N/A').trim();
  }
  return (item?.description || 'N/A').trim();
}

export function getActivoPrintLabel(activo) {
  return (activo?.name || activo?.code || 'Activo').trim();
}

export function sortGuideItemsAlphabetically(items) {
  return [...(items || [])].sort((a, b) =>
    compareLabels(getGuideItemPrintLabel(a), getGuideItemPrintLabel(b))
  );
}

export function sortDocumentItemsAlphabetically(items) {
  return [...(items || [])].sort((a, b) =>
    compareLabels(getDocumentItemPrintLabel(a), getDocumentItemPrintLabel(b))
  );
}

export function sortActivosAlphabetically(activos) {
  return [...(activos || [])].sort((a, b) =>
    compareLabels(getActivoPrintLabel(a), getActivoPrintLabel(b))
  );
}

/**
 * Líneas unificadas para impresión/PDF de documentos (productos, servicios y activos).
 */
export function buildSortedDocumentPrintLines(document) {
  const lines = [
    ...(document?.items || []).map((item) => ({
      type: 'item',
      data: item,
      label: getDocumentItemPrintLabel(item),
    })),
    ...(document?.activos || []).map((activo) => ({
      type: 'activo',
      data: activo,
      label: getActivoPrintLabel(activo),
    })),
  ];

  return lines.sort((a, b) => compareLabels(a.label, b.label));
}
